export default function gerarIdHashProductFruits(length: number): string {
  // Função utilizada pela docs do product fruits: https://help.productfruits.com/en/article/sites-without-authentication

  let result = ''
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}
